<template>
  <section class="login-form rows justify-center align-items-center">
    <div class="form-pad cols align-items-center">
      <h2 class="title">{{ $t('login.title') }}</h2>
      <p class="subtitle">{{ $t('login.subtitle') }}</p>

      <form class="cols align-items-center" id="loginForm" @submit.prevent="submit">
        <label for="typeEmail">{{ $t('login.username') }}</label>
        <input type="email" id="typeEmail" name="username" autocomplete="username"/>
        <label for="typePassword">{{ $t('login.password') }}</label>
        <input type="password" id="typePassword" name="password" autocomplete="current-password"/>

        <button type="submit" class="login-button" @click="login">{{ $t('login.login') }}</button>
      </form>
    </div>
  </section>
</template>

<script>
import {actions} from '@/assets/js/vue/vuex/actions';
import paths from '@/assets/js/vue/router/paths';
import notification from '@/assets/js/notification';

export default {
  name: 'Login',
  methods: {
    login() {
      const email = document.getElementById('typeEmail').value;
      const password = document.getElementById('typePassword').value;

      this.$store.dispatch(actions.CREATE_SESSION, {email, password}).
          then(() => this.$router.push(paths.home)).
          catch(e => notification.error(this.$t(e.message)));
    },
  },
};
</script>

<style scoped lang="scss">
.login-form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  /* fallback for old browsers */
  background: #6a11cb;
  /* Chrome 10-25, Safari 5.1-6 */
  background: -webkit-linear-gradient(to right, rgba(106, 17, 203, 1), rgba(37, 117, 252, 1));
  /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
  background: linear-gradient(to right, rgba(106, 17, 203, 1), rgba(37, 117, 252, 1));

  .form-pad {
    width: 400px;
    padding: 3rem;
    border-radius: 1rem;

    background-color: #212529;

    .title {
      margin-left: 0;
      font-size: 2rem;
      color: white;
    }

    .subtitle {
      font-size: 1.2rem;
      color: gray;
      text-align: center;
    }

    label {
      margin-top: 20px;
      margin-bottom: 10px;
      color: white;
    }

    .login-button {
      margin-top: 20px;
    }
  }
}
</style>
